import { SUSPEND_REASONS } from '@mogzo/shared';
import { Badge, Notice } from '@mogzo/ui';
import type { Project } from '../lib/api';
import { STATUS_NAMES } from '../lib/format';

/** The project's status in its header: Archived, In development, In review, Live, Suspended. */
export function ProjectStatusChip({ project }: { project: Project }) {
  if (project.archivedAt) return <Badge>Archived</Badge>;
  if (project.status === 'live') {
    return (
      <Badge tone="success" dot>
        Live
      </Badge>
    );
  }
  if (project.status === 'suspended') {
    return (
      <Badge tone="danger" dot>
        Suspended
      </Badge>
    );
  }
  if (project.status === 'in_review') {
    return (
      <Badge tone="warning" dot>
        {STATUS_NAMES.in_review}
      </Badge>
    );
  }
  return <Badge tone="info">{STATUS_NAMES[project.status]}</Badge>;
}

/** On every project page while MOGZO has the game suspended (M23). */
export function SuspendedNotice({ project }: { project: Project }) {
  if (!project.suspendedAt) return null;
  return (
    <Notice tone="danger" title={`${project.name} is suspended`}>
      {project.suspendReason && (
        <p style={{ margin: 0 }}>
          <strong>Reason:</strong> {SUSPEND_REASONS[project.suspendReason]}
        </p>
      )}
      {project.suspendMessage && (
        <p style={{ margin: '4px 0 0', whiteSpace: 'pre-line' }}>
          MOGZO’s message: “{project.suspendMessage}”
        </p>
      )}
      <p style={{ margin: '4px 0 0' }}>
        Nobody but you and MOGZO staff can open the game, and nothing can be published. You can
        still upload and send a new version: once it’s approved, MOGZO reinstates the game and you
        publish it.
      </p>
    </Notice>
  );
}
